import { TERMINAL_FORM } from '../form-terminal-types';
import { displaySelectedValue } from '../../../dropdown';
import { ITerminal } from '../../../../models/terminal.interface';

/**
 * Displays the terminal information on the terminal form
 * 
 * @param {object} data the terminal object
 */
export const displayTerminalInformation = (data: ITerminal[]) => {
  const terminal = data[0];

  //convert sql server datetime to html datetime
  const lastHeartBeat = new Date(terminal.LastHeartbeat);
  const lastTransaction = new Date(terminal.lastTransaction);
  const orderedDate = new Date(terminal.orderedDate);
    
  TERMINAL_FORM.terminalPartner.value = terminal.partnerName;
  TERMINAL_FORM.terminalPartner.setAttribute('data-value', String(terminal.partnerId));
  TERMINAL_FORM.terminalName.value = terminal.terminalId!;
  TERMINAL_FORM.terminalDescription.value = terminal.terminalDescription! || terminal.terminalName;
  TERMINAL_FORM.terminalLastHeartbeat.value= lastHeartBeat.toISOString().split('T')[0] + ' ' + lastHeartBeat.toTimeString().split(' ')[0];
  TERMINAL_FORM.terminalLastTransaction.value = lastTransaction.toISOString().split('T')[0] + ' ' + lastTransaction.toTimeString().split(' ')[0];
  TERMINAL_FORM.terminalCostCents.value = String(terminal.costCents);
  TERMINAL_FORM.terminalMarginCents.value = String(terminal.defaultMarginCents);
  TERMINAL_FORM.terminalAddressOne.value = terminal.addressStreet1;
  TERMINAL_FORM.terminalAddressTwo.value = terminal.addressStreet2!;
  TERMINAL_FORM.terminalAddressCity.value = terminal.addressCity;
  TERMINAL_FORM.terminalAddressZip.value = terminal.addressZip;
  TERMINAL_FORM.terminalRegion.value = terminal.region;
  TERMINAL_FORM.terminalSvcBranch.value = terminal.servicingBranch;
  TERMINAL_FORM.terminalCustList.value = terminal.customerList;
  TERMINAL_FORM.terminalContactName.value = terminal.contact1Name;
  TERMINAL_FORM.terminalContactPhone.value = terminal.contact1Phone;
  TERMINAL_FORM.terminalContactEmail.value = terminal.contact1Email;
  TERMINAL_FORM.terminalContactNameTwo.value = terminal.contact2Name;
  TERMINAL_FORM.terminalContactPhoneTwo.value = terminal.contact2Phone;
  TERMINAL_FORM.terminalContactEmailTwo.value = terminal.contact2Email;
  TERMINAL_FORM.terminalContactNameThree.value = terminal.contact3Name;
  TERMINAL_FORM.terminalContactPhoneThree.value = terminal.contact3Phone;
  TERMINAL_FORM.terminalContactEmailThree.value = terminal.contact3Email;
  TERMINAL_FORM.terminalNotes.value = terminal.notes;

  if (TERMINAL_FORM.terminalDefaultPricing && terminal.defaultPrice) TERMINAL_FORM.terminalDefaultPricing.value = terminal.defaultPrice;
  if (TERMINAL_FORM.terminalNational && terminal.national) TERMINAL_FORM.terminalNational.checked = terminal.national === '1';
  if (TERMINAL_FORM.terminalOutOfService && terminal.outOfService) TERMINAL_FORM.terminalOutOfService.checked = terminal.outOfService === 1;
  if (TERMINAL_FORM.terminalTransactionFee && terminal.transactionFee) TERMINAL_FORM.terminalTransactionFee.value = String(terminal.transactionFee);
  if (TERMINAL_FORM.terminalFee && terminal.TerminalFee) TERMINAL_FORM.terminalFee.value = String(terminal.TerminalFee);
  if (TERMINAL_FORM.terminalSerialNum && terminal.serialNumber) TERMINAL_FORM.terminalSerialNum.value = terminal.serialNumber;
  if (TERMINAL_FORM.terminalIpAddress && terminal.ipAddress) TERMINAL_FORM.terminalIpAddress.value = terminal.ipAddress;
  if (TERMINAL_FORM.terminalOrderedDate && terminal.orderedDate) TERMINAL_FORM.terminalOrderedDate.value = orderedDate.toISOString().split('T')[0];
  if (TERMINAL_FORM.terminalMonitorSerialNumber && terminal.monitorSerialNumber) TERMINAL_FORM.terminalMonitorSerialNumber.value = terminal.monitorSerialNumber;
  if (TERMINAL_FORM.terminalGPSLatitude && terminal.gpsLatitude) TERMINAL_FORM.terminalGPSLatitude.value = terminal.gpsLatitude;
  if (TERMINAL_FORM.terminalGPSLongitude && terminal.gpsLongitude) TERMINAL_FORM.terminalGPSLongitude.value = terminal.gpsLongitude;
  if (TERMINAL_FORM.terminalInternalNotes && terminal.internalNotes) TERMINAL_FORM.terminalInternalNotes.value = terminal.internalNotes;
  if (TERMINAL_FORM.terminalAccessDesc && terminal.accessDescription) TERMINAL_FORM.terminalAccessDesc.value = terminal.accessDescription;

  displaySelectedValue('.aafp_list-state', 'state', terminal.addressState);
  displaySelectedValue('.aafp_list-one', 'one', terminal.billingType === 'Bulk' ? 'B' : 'T');
  displaySelectedValue('.aafp_list-two', 'two', terminal.status === 'Active' ? '1' : '0');
  displaySelectedValue('.aafp_list-public', 'public', terminal.publicTerminal === 1 ? 'Public' : 'Private');
}